export default __webpack_public_path__ + "static/media/edgar-timeline-in-progress-step.6da18134.svg";